import { Brand, UserInfo } from 'types';
import { getLocalStorageItem } from 'helpers/local-storage';
import { LocalStorageKeys } from 'commons/local-storage';

export function getUserToken(): {
  store: string;
  brand: Brand;
  accessToken: string;
  refreshToken: string;
} {
  const storedData = getLocalStorageItem(LocalStorageKeys.SelectedStore, {});

  if (!storedData.access) return storedData;

  const { brand, access, name } = storedData;
  const [accessToken, refreshToken] = access.split('|');

  return {
    store: name,
    brand,
    accessToken,
    refreshToken,
  };
}

export function getAllUserTokens(): UserInfo {
  const user = getLocalStorageItem(LocalStorageKeys.User, {});

  return user;
}
